import NotificationOptions from "./NotificationOptions"
import FormatTime from "./FormatTime"

export default ({ children, timestamp, options }) => (
  <>
    <div className="w-100">
      {children}
      <FormatTime timestamp={timestamp} />
    </div>
    <NotificationOptions options={options} />
  </>
)